import React from "react";
import styled from "styled-components";
import { ReactComponent as FinancialsFilter } from "../../../Assets/Icons/FinancialsFilter.svg";
import { HeaderSection, MainContainer } from "../index.styled";
import CustomSlider from "../../CustomSlider";
import { viewSizeCalculator } from "../../../utils";
import Info from "../../Info";

const FinancialAndOperational = ({
  data,
  reference,
  filteredData,
  handleInputChange,
  onReset,
  isFetching,
}) => {
  const fields = data.fields;

  const handleReset = () => {
    handleInputChange("net_patient_revenue_min", "");
    handleInputChange("net_patient_revenue_max", "");
    handleInputChange("net_income_margin_min", "");
    handleInputChange("net_income_margin_max", "");

    if (onReset) {
      onReset();
    }
  };

  return (
    <MainContainer ref={reference}>
      <HeaderSection>
        <FinancialsFilter />
        {data.category}
      </HeaderSection>
      <ContentWrapper>
        <RowContainer wrap={false}>
          <Info
            showArrow={false}
            config={{
              tooltipText: isFetching
                ? "Bear with us we're fetching the data"
                : !!filteredData.hospital_name
                  ? "Can't edit as a Hospital has already been selected"
                  : null,
              position: "top",
              offsetY: -10,
            }}
          >
            <CustomSlider
              title="Net Patient Revenue (in millions)"
              onChange={handleInputChange}
              minValue={filteredData.net_patient_revenue_min}
              maxValue={filteredData.net_patient_revenue_max}
              unit={"$"}
              showMinMaxFields={true}
              minValueName="net_patient_revenue_min"
              maxValueName="net_patient_revenue_max"
              step={0.1}
              filteredData={filteredData}
              disabled={isFetching || !!filteredData.hospital_name}
              onReset={handleReset}
            />
          </Info>
          <Info
            showArrow={false}
            config={{
              tooltipText: isFetching
                ? "Bear with us we're fetching the data"
                : !!filteredData.hospital_name
                  ? "Can't edit as a Hospital has already been selected"
                  : null,
              position: "top",
              offsetY: -10,
            }}
          >
            <CustomSlider
              title="Net Income Margin"
              onChange={handleInputChange}
              minValue={filteredData.net_income_margin_min}
              maxValue={filteredData.net_income_margin_max}
              unit={"%"}
              showMinMaxFields={true}
              minValueName="net_income_margin_min"
              maxValueName="net_income_margin_max"
              step={0.1}
              filteredData={filteredData}
              disabled={isFetching || !!filteredData.hospital_name}
              onReset={handleReset}
            />
          </Info>
        </RowContainer>
      </ContentWrapper>
    </MainContainer>
  );
};

export default FinancialAndOperational;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-bottom: ${() => `${viewSizeCalculator(1.5)}`};
`;

const RowContainer = styled.div`
  width: ${({ width }) => width || "64.5%"};
  display: flex;
  flex-wrap: ${({ wrap }) => (wrap ? "wrap" : "no-wrap")};
  gap: ${viewSizeCalculator(5.7)};
`;